export enum SideBarKeys {
  COMPONENTS = "components",
  NAVIGATION = "navigation",
  SETTINGS_PROFILES = "settings_profiles",
  DEVELOPER_PREFERENCES = "developer_preferences",
  EMBEDDING = "embedding",
  DEBUGGER = "debugger",
  CUSTOM_COMPONENTS = "custom-components",
  VERSIONS = "versions",
  COMMAND_BAR = "command-bar",
  THEME = "theme",
  AI_CHAT = "ai-chat",
}
